export default {
  // Button text
  queryButton: 'Search',
  addButton: 'Add Scenario Model',
  editButton: 'Edit',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',

  // Table column titles
  sceneNameColumn: 'Scenario Name',
  sceneKeyColumn: 'Scenario Key',
  algorithmNameColumn: 'Algorithm Name',
  extraAlgorithmColumn: 'Extra Algorithm',
  modelPathColumn: 'Model Path',
  createTimeColumn: 'Create Time',
  updateTimeColumn: 'Update Time',
  actionColumn: 'Action',

  // Form labels
  sceneNameLabel: 'Scenario Name',
  sceneKeyLabel: 'Scenario Key',
  algorithmNameLabel: 'Algorithm Name',
  extraAlgorithmLabel: 'Extra Algorithm',
  modelLabel: 'Model',
  labelLabel: 'Label',
  modelPathLabel: 'Model Path',

  // Form placeholders
  sceneKeyPlaceholder: 'Please enter scenario key',
  sceneNamePlaceholder: 'e.g.: Public Security Enforcement',
  sceneKeyExamplePlaceholder: 'e.g.: public_security.person_count',
  algorithmNamePlaceholder: 'e.g.: Person Recognition/Counting',
  extraAlgorithmPlaceholder: 'e.g.: Object Detection/Tracking (ByteTrack/DeepSORT optional), Cross-frame Deduplication Counting, Area Filtering',
  selectModelPlaceholder: 'Please select model',
  labelPlaceholder: 'Auto-filled after model selection',
  modelPathPlaceholder: 'Auto-filled after model selection',

  // Validation messages
  sceneNameRequired: 'Please enter scenario name',
  sceneKeyRequired: 'Please enter scenario key',
  algorithmNameRequired: 'Please enter algorithm name',
  extraAlgorithmRequired: 'Please enter extra algorithm',
  modelRequired: 'Please select model',
  labelRequired: 'Please select model first',
  modelPathRequired: 'Please select model first',

  // Modal titles
  addTitle: 'Add Scenario Model',
  editTitle: 'Edit Scenario Model',

  // Confirmation dialogs
  deleteConfirm: 'Delete {name}?',

  // Success messages
  addSuccess: 'Added successfully',
  editSuccess: 'Modified successfully',
  deleteSuccess: 'Deleted successfully',
}
